/**
 * Chapita con la inicial de un personaje, pegada a su retrato.
 *
 * En una casilla de 44 px el retrato se queda en 32 px, y a ese tamaño ocho siluetas se
 * distinguen peor de lo que promete el papel — sobre todo en escala de grises. La
 * inicial resuelve la duda sin ocupar sitio, y es la misma letra que aparece en las
 * anotaciones a lápiz y en el panel del reparto, así que se aprende una sola vez.
 *
 * Decorativa para el lector de pantalla: el nombre completo ya va en el `aria-label` de
 * la casilla.
 */

export function InitialBadge({ initials }: { initials: string }) {
  return (
    <span
      aria-hidden="true"
      className="bg-surface-raised text-text border-border absolute -right-1 -bottom-1 grid h-4 min-w-4 place-items-center rounded-full border px-0.5 font-mono text-[0.5625rem] leading-none"
    >
      {initials}
    </span>
  );
}
